import { Injectable } from '@angular/core';
import { ServerConnectionService } from '../server-connection.service';
import { CoreModule } from '../../core.module';
import { OrderService } from './order.service';

const BASE_UPSELL_URI = '/api/upsell';
const ENDPOINT_FETCH_UPSELL_BY_SITE_ADVERT = `${BASE_UPSELL_URI}/fetch-upsell-by-advert`;
const ENDPOINT_ADD_UPSELL_TO_CART = `${BASE_UPSELL_URI}/add-upsell-to-cart`;

@Injectable({
	providedIn: CoreModule,
})
export class UpsellService {
	constructor(
		private scs: ServerConnectionService,
		private os: OrderService,
	) { }

	public fetchPossibleUpsell(siteAdvertId, pubDate) {
		return this.scs.http$('GET', `${ENDPOINT_FETCH_UPSELL_BY_SITE_ADVERT}/${siteAdvertId}/${pubDate}`, null, null);
	}

	public addUpsellToCart(
		upsellId,
		featureId,
		orderId,
		orderCookie = null,
		applyingDiscount,
		paymentAmount,
		discountAmount,
		promoCode,
		purchaseSource = null,
	) {
		const data = { upsellId, featureId, orderId, orderCookie, applyingDiscount, paymentAmount, discountAmount, promoCode, purchaseSource };
		return new Promise((resolve, reject) => {
			this.scs.http$('POST', `${ENDPOINT_ADD_UPSELL_TO_CART}`, null, data).subscribe(
				(result: any) => {
					if (result.success && result.order) {
						this.os.updateOrderDataStore(result.order);
						resolve(result);
					} else {
						reject(result);
					}
				},
			);
		});
	}
}
